import React, { Component } from "react";

import * as pbi from "powerbi-client";

import {
  checkIsMobile,
  getQueryStringValue,
  getOktaInfo,
  verifyOktaToken,
} from "../../utils";

var report;
var powerbi;
class Secure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportId: "",
      embedToken: "",
      embedUrl: "",
      groupId: "",
      isLoaded: false,
      oktaVerified: false,
    };
    this.powerbiContainerRef = React.createRef();
    this.logoLoaderRef = React.createRef();
    this.refreshTimer = null;
    this.AZURE_FUNCTION_URL =
      "https://pbieembedtokenfunctionapp.azurewebsites.net/api/HttpTriggerRLS?code=lBi6p/LMBEPzamo/YPEsQQd15WzlE8eaf9c3hdOOZta48eEv1O/Rew==";
  }

  async componentDidMount() {
    powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );

    // powerbi.preload({
    //   type: "report",
    //   embedUrl: "https://app.powerbi.com/reportEmbed",
    // })

    powerbi.bootstrap(this.powerbiContainerRef.current, {
      type: "report",
      hostname: `https://app.powerbi.com/reportEmbed`,
    });

    window.addEventListener("orientationchange", this.handleOrientationChange);

    const oktaData = await verifyOktaToken();

    if (oktaData && oktaData.status === 200) {
      const oktaUserInfo = getOktaInfo();

      if (oktaUserInfo) {
        const { name, groups = [], payload = {} } = oktaUserInfo;
        if (name) {
          this.AZURE_FUNCTION_URL = this.AZURE_FUNCTION_URL + `&name=${name}`;
        }
        if (groups.length > 0) {
          this.AZURE_FUNCTION_URL =
            this.AZURE_FUNCTION_URL +
            `&roles="${groups.map((x) => x.toLowerCase()).join('","')}"`;
        }
        if (payload) {
          this.AZURE_FUNCTION_URL =
            this.AZURE_FUNCTION_URL + `&payload=${JSON.stringify(payload)}`;
        }
      }
      this.setState(
        {
          oktaVerified: oktaUserInfo.name,
        },
        () => this.handlePowerBiEmbed()
      );
    }
  }

  componentWillUnmount() {
    clearTimeout(this.refreshTimer);
    window.removeEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
  }

  handleOrientationChange = (e) => {
    report
      .updateSettings({
        layoutType: this.getPBiLayoutVal(),
      })
      .catch((error) => {
        console.log(`update err ===> `, error);
      });
  };

  getPBiLayoutVal = () => {
    const { isMobile, isLandscape } = checkIsMobile();
    const layoutVal = !isMobile
      ? pbi.models.LayoutType.Master
      : isLandscape
      ? pbi.models.LayoutType.MobileLandscape
      : pbi.models.LayoutType.MobilePortrait;
    return layoutVal;
  };

  fetchPowerBiConfig = () => {
    return new Promise((res, rej) => {
      fetch(this.AZURE_FUNCTION_URL)
        .then((response) => response.text())
        .then((response) => response.slice(9, -2))
        .then((response) => res(JSON.parse(JSON.stringify(response))))
        .catch((err) => rej(err));
    });
  };

  attachTokenRefresher = () => {
    var tokenExpiration = 10;
    var minutesToRefresh = 2;

    var currentTime = Date.now();
    var expiration = currentTime + tokenExpiration * 60 * 1000;
    var safetyInterval = minutesToRefresh * 60 * 1000;

    // time until token refresh in milliseconds
    var timeout = expiration - currentTime - safetyInterval;
    // console.log(`timeout ===> `, timeout)
    // if token already expired, generate new token and set the access token
    if (timeout <= 0) {
      // console.log("Updating Report Embed Token")
      this.doTokenUpdate();
    }
    // set timeout so minutesToRefresh minutes before token expires, token will be updated
    else {
      // console.log(
      //   "Report Embed Token will be updated in " + timeout + " milliseconds."
      // )
      this.refreshTimer = setTimeout(() => {
        this.doTokenUpdate();
      }, timeout);
    }
  };

  doTokenUpdate = () => {
    this.fetchPowerBiConfig().then((response) => {
      const { EmbedToken } = JSON.parse(response);
      report
        .setAccessToken(EmbedToken)
        .then(() => {
          console.log("attached");
          this.attachTokenRefresher();
        })
        .catch((err) => {
          console.log(`token update error ===> `, err);
        });
    });
  };

  handlePowerBiEmbed = () => {
    this.fetchPowerBiConfig().then((response) => {
      const { EmbedToken, EmbedUrl, ReportId } = JSON.parse(response);

      // powerbi.bootstrap(this.powerbiContainerRef.current, {
      //   type: "report",
      //   embedUrl: EmbedUrl,
      // })

      if (EmbedToken === null) return;

      const groupId = getQueryStringValue(EmbedUrl, "groupId");

      const permissions = pbi.models.Permissions.All;
      var config = {
        type: "report",
        tokenType: pbi.models.TokenType.Embed,
        accessToken: EmbedToken,
        embedUrl: EmbedUrl,
        id: ReportId,
        permissions: permissions,
        settings: {
          panes: {
            filters: {
              visible: false,
            },

            pageNavigation: {
              visible: false,
            },
          },
          layoutType: this.getPBiLayoutVal(),
        },
      };
      this.setState(
        {
          isLoaded: true,
          reportId: ReportId,
          embedToken: EmbedToken,
          embedUrl: EmbedUrl,
          groupId,
        },
        () => {
          // console.log(powerbi)
          // Embed the report and display it within the div container.
          report = powerbi.embed(this.powerbiContainerRef.current, config);

          // Report.off removes a given event handler if it exists.
          report.off("loaded");

          // Report.on will add an event handler which prints to Log window.
          report.on("loaded", () => {
            // console.log("Loaded")
            this.logoLoaderRef.current.style.opacity = 0;
            setTimeout(() => {
              this.logoLoaderRef.current.style.display = "none";
              this.powerbiContainerRef.current.style.opacity = 1;
            }, 200);
          });

          // Report.off removes a given event handler if it exists.
          report.off("rendered");

          // Report.on will add an event handler which prints to Log window.
          report.on("rendered", () => {
            // console.log("Rendered")
            this.attachTokenRefresher();
          });

          // report.generateEmbedToken()

          report.on("error", (event) => {
            // console.log(event.detail)

            report.off("error");
          });
        }
      );
    });
  };

  render() {
    const { oktaVerified } = this.state;

    return (
      <React.Fragment>
        <div className="nesterra-loader" ref={this.logoLoaderRef}>
          <div className="loader-container">
            <img src={require("../../nesterra.png")} alt="" />
            <span className="top-auth">Authenticating...</span>

            {oktaVerified && (
              <div className="user-name-loader flex">
                <span className="flex">Hi {oktaVerified.split(" ")[0]}!</span>
                <span className="flex">&nbsp;&nbsp;...Almost there!</span>
              </div>
            )}
          </div>
        </div>

        <div
          className="powerbi-client-container"
          ref={this.powerbiContainerRef}
        ></div>
      </React.Fragment>
    );
  }
}

export default Secure;



// WEBPACK FOOTER //
// ./src/components/pages/Secure.js